import { createFileRoute, redirect } from "@tanstack/react-router";

// The general management page was for brands; since Adkiro became property-only
// on 30 Sep 2026, its links land on the property service page instead.
export const Route = createFileRoute("/meta-ads-management")({
  beforeLoad: () => {
    throw redirect({ to: "/real-estate-lead-generation-meta-ads", statusCode: 301 });
  },
});
